module.exports = __webpack_public_path__ + "img/dashboardIcon2.5ac32294.png";